module.exports = __webpack_public_path__ + "img/acacia-light-logo-svg.12e4319e.svg";